import { render } from "./StatSecondaryCard.vue?vue&type=template&id=191d5410"
import script from "./StatSecondaryCard.vue?vue&type=script&lang=js"
export * from "./StatSecondaryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__